export const checkboxTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
    width: 'var(--check-radio-dimension)',
    height: 'var(--check-radio-dimension)',
    transitionDuration: '0.2s',
    focusRing: {
      offset: 'var(--reset)',
      shadow: 'var(--focus-ring)',
      width: 'var(--reset)',
    },
  },
  icon: {
    size: 'var(--font-size-lg)',
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--transparent)',
        borderColor: 'var(--text-color-secondary)',
        hoverBorderColor: 'var(--p-primary-500)',
        checkedHoverBackground: 'var(--p-primary-500)',
        checkedHoverBorderColor: 'var(--p-primary-500)',
        checkedBorderColor: 'var(--p-primary-500)',
        checkedDisabledBorderColor: 'var(--p-surface-500)',
        filledBackground: 'var(--p-primary-500)',
        disabledBackground: 'var(--p-surface-500)',
        focusRing: {
          color: 'var(--p-primary-500)',
        },
      },
      icon: {
        color: 'var(--white)',
        checkedColor: 'var(--white)',
        checkedHoverColor: 'var(--white)',
        disabledColor: 'var(--white)',
      },
      extend: {
        agility: {
          unfilled: {
            disabled: {
              background: 'var(--p-surface-100)',
              border: {
                color: 'var(--p-surface-300)',
              },
            },
            icon: {
              color: 'var(--text-color)',
            },
          },
          indeterminate: {
            icon: {
              color: 'var(--text-color)',
            },
          },
        },
      },
    },
    dark: {
      root: {
        background: 'var(--transparent)',
        borderColor: 'var(--text-color-secondary)',
        hoverBorderColor: 'var(--p-primary-500)',
        checkedHoverBackground: 'var(--p-primary-500)',
        checkedHoverBorderColor: 'var(--p-primary-500)',
        checkedBorderColor: 'var(--p-primary-500)',
        checkedDisabledBorderColor: 'var(--p-surface-500)',
        filledBackground: 'var(--p-primary-500)',
        disabledBackground: 'var(--p-surface-500)',
        focusRing: {
          color: 'var(--p-primary-500)',
        },
      },
      icon: {
        color: 'var(--p-white)',
        checkedColor: 'var(--p-white)',
        checkedHoverColor: 'var(--p-white)',
        disabledColor: 'var(--p-white)',
      },
      extend: {
        agility: {
          unfilled: {
            disabled: {
              background: 'var(--p-surface-100)',
              border: {
                color: 'var(--p-surface-300)',
              },
            },
            icon: {
              color: 'var(--text-color)',
            },
          },
          indeterminate: {
            icon: {
              color: 'var(--text-color)',
            },
          },
        },
      },
    },
  },
  css: ({ dt }: any) => `
    .p-checkbox.p-disabled:not(.p-checkbox-checked) .p-checkbox-box {
      background: ${dt('checkbox.agility.unfilled.disabled.background')} !important;
      border-color: ${dt('checkbox.agility.unfilled.disabled.border.color')} !important;
    }

    .p-checkbox:not(.p-checkbox-checked)
    .p-checkbox-icon {
      color: ${dt('checkbox.agility.unfilled.icon.color')} !important;
    }
  `,
};
